<h2 mat-dialog-title>Senha do Certificado</h2>

<mat-dialog-content>
  @if (isLoading) {
  <div class="loading-container">
    <mat-spinner [diameter]="50"></mat-spinner>
    <p>Buscando senha...</p>
  </div>
  } @else {
  <div class="senha-container">
    <p class="senha-valor">{{ senha }}</p>
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="action-buttons">
  <button mat-flat-button class="btn-primary" (click)="close()">Fechar</button>
</mat-dialog-actions>